// Copied from advisor-3.0/src/components/Footer/Footer.js
// Changes: sessionStorage -> useAccount, useLocation from react-router-dom v7, TS types
import { useState, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import SupportModal from 'src/components/Layout/SupportModal';
import FooterModalPopup from './FooterModalPopup';
import AccessibilityPolicy from 'src/components/Disclosure/AccessibilityPolicy';
import PrivacyPolicy from 'src/components/Disclosure/PrivacyPolicy';
import TermsAndConditions from 'src/components/Disclosure/TermsAndConditions';
import StateDisclosure from 'src/components/Disclosure/StateDisclosure';
import { useAccount } from 'src/api/hooks/useAccount';
import './Footer.scss';

const links = {
  Terms: 'TermsAndConditions',
  Security: 'SecurityAndPrivacyPolicy',
  Accessibility: 'AccessibilityPolicy',
  Contact: 'ContactUs',
  StateLicense: 'StateLicenseDisclosure',
};

interface FooterProps {
  expanded: boolean;
  isSignWithoutAuth?: boolean;
}

export default function Footer({ expanded, isSignWithoutAuth }: FooterProps) {
  const location = useLocation();
  const year = new Date().getFullYear();
  const isLandingPage = location.pathname.toLowerCase().indexOf('landing') > -1;
  const isSinglePremiumWholeLife = location.pathname.toLowerCase().indexOf('single-premium-whole-life') > -1;

  const { data } = useAccount();
  const accountId = data?.account?.accountId || '';

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [renderComponent, setRenderComponent] = useState<ReactNode>(null);

  const onButtonClick = (linkName: string) => {
    if (linkName === links.Contact) {
      setModalOpen(true);
    } else if (linkName === links.Terms) {
      setRenderComponent(<TermsAndConditions />);
      setInfoDialogOpen(true);
    } else if (linkName === links.Security) {
      setRenderComponent(<PrivacyPolicy />);
      setInfoDialogOpen(true);
    } else if (linkName === links.Accessibility) {
      setRenderComponent(<AccessibilityPolicy />);
      setInfoDialogOpen(true);
    } else if (linkName === links.StateLicense) {
      setRenderComponent(<StateDisclosure />);
      setInfoDialogOpen(true);
    }
  };

  const covrDisclaimer = () => (
    <span>
      {isSinglePremiumWholeLife && (
        <p>Secure Legacy is not available in New York. Insurance products are issued by Minnesota Life Insurance Company or Securian Life Insurance Company, a New York authorized insurer.</p>
      )}
      <span>
        Insurance products are sold through Covr Financial Technologies Inc (&quot;Covr&quot;). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229). All other state license numbers are available on our{' '}
        <Button variant="text" className={isLandingPage ? 'link-color' : ''} onClick={() => onButtonClick(links.StateLicense)}>
          State License Disclosure Page
        </Button>
        .
      </span>
    </span>
  );

  return (
    <footer className={`${isSignWithoutAuth ? 'ml-0' : ''} footer py-3 flex-fill ${expanded ? 'sidebar-open' : 'sidebar-close'}`}>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="row justify-content-center">
            <div className={isLandingPage ? 'col-lg-11' : 'col-lg-6'}>
              <small>{covrDisclaimer()}</small>
            </div>
          </div>
          <div className="row justify-content-center my-4 links">
            {!isLandingPage && (
              <div className="col-12 col-sm d-flex align-items-center justify-content-center">
                <Button variant="text" onClick={() => onButtonClick(links.Terms)}>Terms &amp; Conditions</Button>
              </div>
            )}
            <div className="col-12 col-sm d-flex align-items-center justify-content-center">
              <Button variant="text" className={isLandingPage ? 'link-color' : ''} onClick={() => onButtonClick(links.Security)}>
                Security &amp; Privacy Policy
              </Button>
            </div>
            <div className="col-12 col-sm d-flex align-items-center justify-content-center">
              <Button variant="text" className={isLandingPage ? 'link-color' : ''} onClick={() => onButtonClick(links.Accessibility)}>
                Accessibility Policy
              </Button>
            </div>
            {!isLandingPage && (
              <>
                <div className="col-12 col-sm d-flex align-items-center justify-content-center">
                  <Button variant="text" onClick={() => onButtonClick(links.Contact)}>Contact Us</Button>
                </div>
                <div className="col-12 col-sm d-flex align-items-center justify-content-center">
                  <span>Account ID: {accountId}</span>
                </div>
              </>
            )}
            {isLandingPage && (
              <div className="col-12 col-sm d-flex align-items-center justify-content-center">
                <span>Copyright &copy; {year}</span>
              </div>
            )}
          </div>
          <div className="row justify-content-center"><strong>Powered by</strong></div>
          <div className="row justify-content-center">
            <img src="/logos/covr-logo.svg" alt="Covr Logo" />
          </div>
          <div className="row justify-content-center covr">Covr Financial Technologies</div>
          <div className="row justify-content-center">Hartford. Boise. Colorado Springs.</div>
          {!isLandingPage && <div className="row justify-content-center">Copyright &copy; {year}</div>}
        </div>

        <FooterModalPopup open={infoDialogOpen} onDialogClose={() => setInfoDialogOpen(false)} component={renderComponent} />
        <SupportModal open={modalOpen} handleClose={() => setModalOpen(false)} />
      </div>
    </footer>
  );
}
